<template>
  <v-row>
    <v-col v-if="lockControlsIntegrationOrder">
      O pedido está sendo enviado para o seu ERP. Confira no painel de detalhes
      os registros da sua integração e/ou no seu ERP. Caso haja críticas ao
      pedido, avalie-as para que a sua integração ao ERP seja concluída. Uma vez
      que o pedido esteja criado no seu ERP, toda edição deve ser feita por ele.
      <br />
      Para alterar o status manualmente, use a
      <a href="/fornecedor/configuracao/manutencao-mix">Manutenção avançada</a>
      <v-alert type="info" class="my-3" v-if="this.pedido.id_pedido_erp">
        <span>
          Esse pedido existe no seu ERP com o número:
          <span class="font-weight-bold ml-2">
            {{ this.pedido.id_pedido_erp }}
          </span>
        </span>
      </v-alert>
      <LineDivider v-if="isLoading" />
      <p class="text-start my-0" v-if="isLoading">Aguarde...</p>
    </v-col>
    <v-col v-else>
      <div v-if="selectAction.length === 0">
        <p>
          {{ message }}
        </p>
      </div>
      <div v-else>
        <FormButton
          v-for="item in selectAction"
          :key="item"
          :type="actions[item].buttonStyle"
          class="font-weight-bold"
          @click="executarAcao(item)"
          :loading="isLoading"
        >
          {{ actions[item].actionText }}
        </FormButton>
      </div>
    </v-col>
    <v-col cols="12">
      <v-alert
        type="info"
        color="indigo"
        class="mt-n5 mb-n2"
        v-if="pedido.pedidooriginal"
      >
        <span v-if="pedido.pedidooriginal === pedido.numpedido">
          Esse pedido originou os seguintes pedidos: <br />
          <template
            v-if="pedido.pedidosquebrados && pedido.pedidosquebrados.length > 0"
          >
            <span v-for="(item, i) in pedido.pedidosquebrados" :key="i">
              <FormButton
                flat
                outlined
                class="font-weight-bold mr-3 mt-2"
                @click="onClickBreak(item)"
              >
                {{ item }}
              </FormButton>
            </span>
          </template>
        </span>
        <span v-else>
          Esse pedido tem origem do desmembramento do pedido número:
          <FormButton
            flat
            outlined
            class="font-weight-bold"
            @click="onClickBreak(pedido.pedidooriginal)"
          >
            {{ pedido.pedidooriginal }}
          </FormButton>
        </span>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import * as _ from "lodash";
import FormButton from "@/components/form/FormButton";
import LineDivider from "@/components/LineDivider";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { mapGetters } from "vuex";
import OrderStatus from "../../../../utils/orderStatus";
import {
  PEDIDO_ACTIONS_INIT_DELIVERY,
  PEDIDO_ACTIONS_CONFIRM_DELIVERY,
  PEDIDO_ACTIONS_ACCEPT_QUOTE,
  PEDIDO_ACTIONS_CONCLUDE_SEPARATION,
  PEDIDO_ACTIONS_CONCLUDE_WITHDRAWAL,
  PEDIDO_ACTIONS_CONFIRM_PAYMENT,
  PEDIDO_ACTIONS_INIT_SEPARATION,
  PEDIDO_ACTIONS_SUBMIT_QUOTE,
  PEDIDO_LOG,
  PEDIDO_UPDATE_RESPONSABLE
} from "@/store/actions/pedido";

export default {
  components: {
    FormButton,
    LineDivider
  },
  data() {
    return {
      isLoading: false,
      actions: [
        {
          actionText: "Aceitar orçamento",
          buttonStyle: "success",
          actionHandler: "aceitarOrcamento"
        },
        {
          actionText: "Submeter novo pedido",
          buttonStyle: "primario",
          actionHandler: "submeterOrcamentoParaPedido"
        },
        {
          actionText: "Iniciar atendimento",
          buttonStyle: "primary",
          actionHandler: "iniciarAtendimento"
        },
        {
          actionText: "Iniciar separação",
          buttonStyle: "primary",
          actionHandler: "iniciarSeparacao"
        },
        {
          actionText: "Concluir separação",
          buttonStyle: "info",
          actionHandler: "concluirSeparacao"
        },
        {
          actionText: "Iniciar entrega",
          buttonStyle: "primario",
          actionHandler: "iniciarEntregaPedido"
        },
        {
          actionText: "Marcar como entregue",
          buttonStyle: "success",
          actionHandler: "confirmarEntregaPedido"
        },
        {
          actionText: "Concluir retirada",
          buttonStyle: "success",
          actionHandler: "concluirRetiradaPedido"
        },
        {
          actionText: "Confirmar pagamento",
          buttonStyle: "warning",
          actionHandler: "confirmarPagamentoManual"
        }
      ],
      selectAction: [],
      modulosForm: [
        ModulesEnum.ORCAMENTO_WEB,
        ModulesEnum.ORCAMENTO_APP,
        ModulesEnum.VENDAMAIS_WEB,
        ModulesEnum.VENDAMAIS_APP,
        ModulesEnum.WEB_COMMERCE,
        ModulesEnum.COMMERCE_APP
      ]
    };
  },
  props: {
    pedido: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      "moduloFornecedorAtivo",
      "getUsuarioId",
      "getFornecedorTag"
    ]),
    hasResponsavel() {
      return !!_.get(
        this.pedido,
        "responsavel_atendimento.responsavel.atendimento",
        ""
      );
    },
    finishOrderManually() {
      return this.getFornecedorTag["finish-order-manually"];
    },
    statusOrder() {
      return OrderStatus.OrderStatus;
    },
    lockControlsIntegrationOrder() {
      const acaoManual =
        this.finishOrderManually &&
        (this.pedido.statuspedido === this.statusOrder.SEPARANDO ||
          this.pedido.statuspedido === this.statusOrder.PAGO ||
          this.pedido.statuspedido === this.statusOrder.PRONTO_RETIRADA ||
          this.pedido.statuspedido === this.statusOrder.EMENTREGA ||
          this.pedido.statuspedido === this.statusOrder.ENTREGUE);
      return !acaoManual && this.pedido.id_pedido_erp;
    },
    message() {
      const statusPedidoEnum = {
        [this.statusOrder.AGUARDANDOPAGAMENTO]:
          "aguardando confirmação de pagamento",
        [this.statusOrder.EM_ANALISE]: "em análise"
      };

      const statusDescricao =
        statusPedidoEnum[this.pedido.statuspedido] || "entregues ou cancelados";

      return `Nenhuma ação permitida neste pedido (Pedidos ${statusDescricao} não podem ser modificados)`;
    }
  },
  methods: {
    onClickBreak(item) {
      const url = this.$router.resolve({
        path: `/fornecedor/pedidos/detalhes/${item}`
      }).href;
      window.open(url, "_blank");
    },
    setupAcoes() {
      const modulosOrcamento = [
        ModulesEnum.ORCAMENTO_WEB,
        ModulesEnum.ORCAMENTO_APP
      ];
      const modulosPedido = [ModulesEnum.WEB_COMMERCE];
      switch (this.pedido.statuspedido) {
        case this.statusOrder.ORCAMENTO_NOVO: {
          this.selectAction = this.moduloFornecedorAtivo(modulosOrcamento)
            ? [0]
            : [];
          break;
        }
        case this.statusOrder.ORCAMENTO_PRECIFICADO: {
          this.selectAction = this.moduloFornecedorAtivo(modulosPedido)
            ? [1]
            : [];
          break;
        }
        case this.statusOrder.ENVIADO: {
          this.selectAction = this.hasResponsavel ? [3] : [2];
          break;
        }
        case this.statusOrder.SEPARANDO:
          this.selectAction = [4];
          break;
        case this.statusOrder.AGUARDANDOPAGAMENTO: {
          this.selectAction = this.pedido.requer_aprovacao_manual ? [8] : [];
          break;
        }
        case this.statusOrder.PAGO:
          this.selectAction = [5];
          break;
        case this.statusOrder.EMENTREGA:
          this.selectAction = [6];
          break;
        case this.statusOrder.PRONTO_RETIRADA:
          this.selectAction = [7];
          break;
        case this.statusOrder.ENTREGUE:
        case this.statusOrder.CANCELADO:
          this.selectAction = [];
          break;
      }
    },
    executarAcao(acao) {
      this[this.actions[acao].actionHandler]();
    },
    successChangeOrder(data) {
      this.$emit("enviar-msg-chat", data);
      this.$vueOnToast.pop(
        data.status || "success",
        data.message || "Pedido atualizado com sucesso"
      );
      const acaoManual =
        this.pedido.id_pedido_erp &&
        (this.pedido.statuspedido === this.statusOrder.PAGO ||
          this.pedido.statuspedido === this.statusOrder.PRONTO_RETIRADA ||
          this.pedido.statuspedido === this.statusOrder.EMENTREGA ||
          this.pedido.statuspedido === this.statusOrder.ENTREGUE);

      if (acaoManual) {
        const data = {
          numpedido: this.pedido.numpedido,
          status: data.data && data.data.status ? data.data.status : ""
        };
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_LOG, data)
          .then(() => {
            this.isLoading = false;
            setTimeout(() => location.reload(), 1500);
          })
          .catch(() => {
            this.isLoading = false;
            setTimeout(() => location.reload(), 1500);
          });
      } else {
        setTimeout(() => location.reload(), 1500);
      }
    },
    iniciarEntregaPedido() {
      const data = {
        idcliente: this.pedido.idcliente,
        numpedido: this.pedido.numpedido
      };
      const options = {
        title: "Confirma o início da entrega deste pedido?"
      };
      this.confirmSwal(options, () => {
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_ACTIONS_INIT_DELIVERY, data)
          .then(data => {
            const response = data.data;
            this.successChangeOrder(response);
            this.isLoading = false;
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Falha ao atualizar pedido");
            this.isLoading = false;
          });
      });
    },
    confirmarEntregaPedido() {
      const data = {
        idcliente: this.pedido.idcliente,
        numpedido: this.pedido.numpedido
      };
      const options = {
        title: "Confirma a entrega deste pedido?"
      };
      this.confirmSwal(options, () => {
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_ACTIONS_CONFIRM_DELIVERY, data)
          .then(data => {
            const response = data.data;
            this.successChangeOrder(response);
            this.isLoading = false;
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Falha ao atualizar pedido");
            this.isLoading = false;
          });
      });
    },
    aceitarOrcamento() {
      const data = {
        idcliente: this.pedido.idcliente,
        numpedido: this.pedido.numpedido
      };
      const options = {
        title: "Confirma a aceitação deste orçamento?"
      };
      this.confirmSwal(options, () => {
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_ACTIONS_ACCEPT_QUOTE, data)
          .then(data => {
            const response = data.data;
            this.successChangeOrder(response);
            this.isLoading = false;
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Falha ao atualizar pedido");
            this.isLoading = false;
          });
      });
    },
    submeterOrcamentoParaPedido() {
      const data = {
        idcliente: this.pedido.idcliente,
        numpedido: this.pedido.numpedido
      };
      const options = {
        title: "Confirma submissão de um novo pedido com esse orçamento?"
      };
      this.confirmSwal(options, () => {
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_ACTIONS_SUBMIT_QUOTE, data)
          .then(data => {
            const response = data.data;
            this.successChangeOrder(response);
            this.isLoading = false;
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Falha ao atualizar pedido");
            this.isLoading = false;
          });
      });
    },
    iniciarAtendimento() {
      this.iniciarSeparacao(true);
    },
    iniciarSeparacao(change) {
      if (change) {
        if (
          this.pedido.responsavel_atendimento.responsavel &&
          this.pedido.responsavel_atendimento.responsavel.atendimento
        ) {
          this.pedido.responsavel_atendimento.responsavel.atendimento = {
            idusuario: this.getUsuarioId
          };
        } else {
          this.pedido.responsavel_atendimento.responsavel = {
            ...this.pedido.responsavel_atendimento.responsavel,
            atendimento: {
              idusuario: this.getUsuarioId
            }
          };
        }
        const responsavel = {
          idpedido: this.pedido.idpedido,
          responsavel: this.pedido.responsavel_atendimento.responsavel
        };
        this.$store
          .dispatch(PEDIDO_UPDATE_RESPONSABLE, responsavel)
          .then(() => {
            this.isLoading = false;
            this.$vueOnToast.pop(
              "success",
              "Responsável atualizado com sucesso"
            );
          })
          .catch(err => {
            const erro = err.error || "Falha ao atualizar responsável";
            this.$vueOnToast.pop("error", erro);
            this.isLoading = false;
          });
      }
      const data = {
        idcliente: this.pedido.idcliente,
        numpedido: this.pedido.numpedido
      };
      const options = {
        title: "Confirma o início da separação deste pedido?"
      };
      this.confirmSwal(options, () => {
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_ACTIONS_INIT_SEPARATION, data)
          .then(data => {
            const response = data.data;
            this.successChangeOrder(response);
            this.isLoading = false;
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Falha ao atualizar pedido");
            this.isLoading = false;
          });
      });
    },
    concluirSeparacao() {
      const data = {
        idcliente: this.pedido.idcliente,
        numpedido: this.pedido.numpedido,
        tipoentrega: this.pedido.tipo_entrega
      };
      const options = {
        title: "Confirma a conclusão da separação deste pedido?"
      };
      this.confirmSwal(options, () => {
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_ACTIONS_CONCLUDE_SEPARATION, data)
          .then(data => {
            const response = data.data;
            this.successChangeOrder(response);
            this.isLoading = false;
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Falha ao atualizar pedido");
            this.isLoading = false;
          });
      });
    },
    concluirRetiradaPedido() {
      const data = {
        idcliente: this.pedido.idcliente,
        numpedido: this.pedido.numpedido
      };
      const options = {
        title: "Confirma a retirada deste pedido?"
      };
      this.confirmSwal(options, () => {
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_ACTIONS_CONCLUDE_WITHDRAWAL, data)
          .then(data => {
            const response = data.data;
            this.successChangeOrder(response);
            this.isLoading = false;
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Falha ao atualizar pedido");
            this.isLoading = false;
          });
      });
    },
    confirmarPagamentoManual() {
      const data = {
        idcliente: this.pedido.idcliente,
        numpedido: this.pedido.numpedido,
        statuspedido: this.pedido.statuspedido,
        idformapagamento: this.pedido.dadospedido.formaPagamento.idformapagto
      };
      const options = {
        title: "Confirmar manualmente o pagamento desse pedido?"
      };
      this.confirmSwal(options, () => {
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_ACTIONS_CONFIRM_PAYMENT, data)
          .then(data => {
            const response = data.data;
            this.successChangeOrder(response);
            this.isLoading = false;
          })
          .catch(() => {
            this.$vueOnToast.pop("error", "Falha ao atualizar pedido");
            this.isLoading = false;
          });
      });
    }
  },
  mounted() {
    this.setupAcoes();
  }
};
</script>
